import { render, staticRenderFns } from "./OActiveButton.vue?vue&type=template&id=150a8bed&scoped=true&"
import script from "./OActiveButton.vue?vue&type=script&lang=js&"
export * from "./OActiveButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150a8bed",
  null
  
)

export default component.exports